class CartOfferManager {
  constructor() {
    this._timer = null;
    this.init();
  }

  init() {
    document.addEventListener('cart:updated', () => this.debounce());
    this.observeCartDrawer();
    this.updateOffer();
  }

  debounce() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => this.updateOffer(), 300);
  }

  observeCartDrawer() {
    const observer = new MutationObserver(() => this.debounce());
    const target =
      document.getElementById('CartDrawer-CartItems') ||
      document.getElementById('cart-drawer-items');
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  async getCartData() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  // Truthful savings/offer messaging. Only shows numbers that come from a
  // REAL discount Shopify has actually applied to the cart (an Automatic
  // Discount or a valid discount code) -- never a fabricated calculation.
  async updateOffer() {
    const cart = await this.getCartData();
    const hasRealDiscount = cart.total_discount > 0;
    this.updateBannerUI(cart, hasRealDiscount);
    this.updateSavingsMsg(cart, hasRealDiscount);
  }

  updateBannerUI(cart, hasRealDiscount) {
    const banner = document.getElementById('cart-offer-banner');
    if (!banner) return;
    if (hasRealDiscount) {
      const savings = (cart.total_discount / 100).toFixed(2);
      banner.innerHTML = `
        <div class="offer-banner offer-banner--applied">
          <span class="offer-icon">🎯</span>
          <span class="offer-text">
            <strong>Discount applied!</strong> You're saving ₹${savings}.
          </span>
        </div>`;
    } else {
      banner.innerHTML = '';
    }
  }

  updateSavingsMsg(cart, hasRealDiscount) {
    const el = document.querySelector('.cart-yay-savings');
    if (!el) return;
    if (hasRealDiscount) {
      const savings = (cart.total_discount / 100).toFixed(2);
      el.innerHTML = `Yay! You save <strong>₹${savings}</strong> on this order`;
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartOfferManager = new CartOfferManager();
});
